import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { getErrorMessage } from '../services/errorMessages';
import './Login.css';

const Login = () => {
  const [personalNumber, setPersonalNumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasError) {
      setHasError(false);
      setError('');
    }
  }, [personalNumber, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await api.post('/auth/login', {
        personal_number: personalNumber,
        password,
      });
      login(data.user, data.token);
      navigate(data.user.role === 'admin' ? '/users' : '/dashboard');
    } catch (err) {
      setError(getErrorMessage(err));
      setHasError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-left">
          <div className="login-brand">
            <div className="brand-icon">{window.location.hostname.includes('ipiqre') ? 'I' : 'C'}</div>
            <h1>{window.location.hostname.includes('ipiqre') ? 'IPIQRE' : 'CVLILEBEBI'}</h1>
            <p>მართვის სისტემა</p>
          </div>
        </div>
        <div className="login-right">
          <form onSubmit={handleSubmit} className="login-form">
            <h2>შესვლა</h2>
            <p className="login-subtitle">შეიყვანეთ თქვენი მონაცემები</p>

            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label>პირადი ნომერი</label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={personalNumber}
                onChange={(e) => setPersonalNumber(e.target.value.replace(/\D/g, ''))}
                placeholder="შეიყვანეთ პირადი ნომერი"
                required
              />
            </div>

            <div className="form-group">
              <label>პაროლი</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="შეიყვანეთ პაროლი"
                required
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading || hasError}>
              {loading ? 'იტვირთება...' : 'შესვლა'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
